<div class="modal-header">
    <h2 class="modal-title">Vendor PickUp</h2>
</div>
<div class="modal-body" style="min-height: 800px">
    <dx-form *ngIf="pickUp" [formData]="pickUp" [colCount]="2" validationGroup="pickUpValidationGroup">
        <dxi-item itemType="group">
            <dxi-item [label]="{ text: 'Vendor' }">
                <div *dxTemplate>
                    <dx-text-box [value]="vendor?.companyName" [readOnly]="true"></dx-text-box>
                </div>
            </dxi-item>

            <dxi-item [label]="{ text: 'Ship Address' }">
                <div *dxTemplate>
                    <dx-text-box [value]="vendor?.displayAddress" [readOnly]="true"></dx-text-box>
                </div>
            </dxi-item>

            <dxi-item dataField="scheduledDate" editorType="dxDateBox" [isRequired]="true" [editorOptions]="{ width: '150px' }"></dxi-item>
            <dxi-item dataField="numberOfSkids" [editorOptions]="{ width: '150px' }"></dxi-item>
            <dxi-item dataField="totalWeight" [editorOptions]="{ width: '150px' }"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="2">
            <dxi-item dataField="instructions" editorType="dxTextArea" [editorOptions]="{ height: '100px' }"></dxi-item>
            <dxi-item dataField="notes" editorType="dxTextArea" [editorOptions]="{ height: '100px' }"></dxi-item>
        </dxi-item>
    </dx-form>
    <table class="table m-t-sm">
        <thead>
            <tr>
                <th></th>
                <th>Completed</th>
                <th>PickUp Qty</th>
                <th>Order Qty</th>
                <th>PickUp Qty Scheduled</th>
                <th>Received</th>
                <th>PO #</th>
                <th>Part #</th>
                <!-- <th>Rev</th> -->
                <th>Mfg Part #</th>
                <th>Description</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let line of pickUpLines" [ngClass]="line.completed ? 'completed-pickup ' : ''">
                <td>
                    <a *ngIf="!pickUp.completed && !line.completed" title="remove" (click)="remove(line)"><i class="fa fa-times pt-3" style="color: maroon"></i></a>
                </td>
                <td>{{ line.completed | date: 'MM/dd/yyyy' }}</td>
                <td>
                    <dx-number-box [(value)]="line.quantity" [step]="0" width="65" [readOnly]="line.completed">
                        <dx-validator validationGroup="pickUpValidationGroup">
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule
                                type="range"
                                [min]="-9999"
                                [max]="line.quantityReadyToPickUp"
                                message="Amount cannot be greater than the remaining quantity to receive"
                            ></dxi-validation-rule>
                        </dx-validator>
                    </dx-number-box>
                </td>
                <td>{{ line.purchaseOrderLine?.quantity }}</td>
                <td>{{ line.quantityScheduled }}</td>
                <td>{{ line.purchaseOrderLine?.quantityReceived }}</td>
                <td>{{ line.purchaseOrderLine?.purchaseOrder?.pONumber }}</td>
                <td>{{ line.purchaseOrderLine?.partNumber }}</td>
                <!-- <td>{{ line.purchaseOrderLine?.part?.revision }}</td> -->
                <td>{{ line.purchaseOrderLine?.mfgPartNumber }}</td>
                <td>{{ line.purchaseOrderLine?.description }}</td>
            </tr>
        </tbody>
    </table>
</div>

<div class="modal-footer">
    <button class="btn btn-success me-auto" (click)="print()">Print</button>
    <button class="btn btn-danger" (click)="unComplete()" *ngIf="canUnComplete && pickUp.completed">UnComplete</button>
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-default" (click)="cancel()">Cancel</button>
</div>
